import styled from 'styled-components';
import spacing from '../../../helpers/spacing';

export const TableContainer = styled.div`
  margin-top: ${spacing(8)};
  margin-bottom: ${spacing(8)};
`;
